export default __webpack_public_path__ + "static/media/notification-5.50eccfb1.mp3";